import { useCallback, useState } from 'react';
import { toast } from '@/lib/toast';
import { ResponsiveDialog } from '@/components/ResponsiveDialog/ResponsiveDialog';
import { Button } from '@/components/ui/button';

export interface ChatbotIntroModalProps {
    isOpen: boolean;
    onClose: () => void;
    confirm: () => { unwrap: () => Promise<unknown> };
    onConfirmed: () => void;
}

export const ChatbotIntroModal = ({ isOpen, onClose, confirm, onConfirmed }: ChatbotIntroModalProps) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = useCallback(async () => {
        setIsSubmitting(true);
        try {
            await confirm().unwrap();
            onClose();
            onConfirmed();
        }
        catch {
            toast.error('Something went wrong. Please try again.');
        }
        finally {
            setIsSubmitting(false);
        }
    }, [confirm, onClose, onConfirmed]);

    return (
        <ResponsiveDialog
            title="Try ZigBot"
            isOpen={isOpen}
            onClose={onClose}
            footer={(
                <Button
                    variant="primary"
                    className="w-full"
                    size="lg"
                    onClick={onSubmit}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Confirming...' : 'Confirm & open ZigBot'}
                </Button>
            )}
        >
            <p className="text-sm text-secondary-foreground light:text-foreground dark:text-foreground mt-2 mb-2">
                ZigBot is an AI-powered career guidance assistant in early access.
                Features may change as we continue to improve. Use the feedback button
                anytime to share your thoughts, and your input helps shape the experience.
            </p>
        </ResponsiveDialog>
    );
};
